import { useTipTapEditorContext } from "@circle-react-uikit/TipTap/TipTapEditorContext";
import { useBlockEditorContext } from "@circle-react-uikit/TipTapBlockEditor/BlockEditorContext";
import { NodeViewWrapper, type ReactNodeViewProps } from "@tiptap/react";

import { MentionLink } from "./MentionLink";
import { MentionWithProfileLink } from "./MentionWithProfileLink";
import type { Mention } from "./types";

export const MentionsDisplay = ({ node }: ReactNodeViewProps) => {
  const tiptapEditorContext = useTipTapEditorContext();
  const tiptapBlockEditorContext = useBlockEditorContext();
  const {
    sgidToObjectMap = {},
    localSgidToObjectMap = {},
    disableMentionClicks = false,
  } = tiptapEditorContext || tiptapBlockEditorContext || {};

  const mention: Mention | undefined =
    localSgidToObjectMap[node.attrs.sgid] || sgidToObjectMap[node.attrs.sgid];

  if (!mention) {
    return null;
  }

  if (disableMentionClicks) {
    return (
      <NodeViewWrapper as="span">
        <MentionLink mention={mention} />
      </NodeViewWrapper>
    );
  }

  return (
    <NodeViewWrapper as="span">
      <MentionWithProfileLink mention={mention} />
    </NodeViewWrapper>
  );
};
